import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Typography } from '@material-ui/core';
import { useToggle } from 'hooks/useToggle';
import { ModalV2 } from 'components/Modal/ModalV2';
import { TankForm } from './TankForm';
import RegularButton from 'components/CustomButtons/Button';
import { blue, green } from '@material-ui/core/colors';

const val = 500

export const columns = [
  {
    Header: "Unidad",
    accessor: "numberLabel",
    filterable: true,
    filterMethod: (filter, row) =>
      row.numberLabel
        ? row.numberLabel.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) =>
      row.name
        ? row.name.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Tipo",
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) =>
      row.type
        ? row.type.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Latitud",
    accessor: "latitude",
    filterable: true,
    filterMethod: (filter, row) =>
    String(row.latitude)
      ? String(row.latitude).toLowerCase().includes(filter.value.toLowerCase())
      : "",
  },
  {
    Header: "Longitud",
    accessor: "longitude",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.longitude)
        ? String(row.longitude).toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Capacidad",
    accessor: "capacity",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.capacity)
        ? String(row.capacity).toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: "Estatus",
    accessor: "assigned",
    filterable: true,
    Cell: ({ original: { assigned } }) => {
      return (
        <Typography style={{ color: assigned ? blue[val] : green[val] }}>
          {assigned ? 'Asignado' : 'Disponible'}
        </Typography>
      )
    },
    filterMethod: (filter, row) => {
      let value = filter.value.toLowerCase();
      if ('asignado'.includes(value) && 'disponible'.includes(value)) return true;
      if ('asignado'.includes(value)) value = 1;
      if ('disponible'.includes(value)) value = 0;
      return String(row.assigned)
        ? String(row.assigned).toLowerCase().includes(value)
        : "" 
    }
  },
  {
    Header: "Acciones",
    filterable: true,
    Cell: ({ original }) => {
      const [open, setOpen] = useToggle()
      return (
      <>
          <Box style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8
          }}>
            <RegularButton
              justIcon
              round
              color="transparent"
              onClick={setOpen}
              tooltip="Editar Tanque"
            >
              <EditIcon style={{ color: blue[val] }} />
            </RegularButton>
          </Box>
          <ModalV2
            open={open}
            onClose={setOpen}
            title={`Editar Tanque ${original?.name}`}
            justConfirm
          >
            <TankForm onClose={setOpen} tank={original} isEdit />
          </ModalV2>
        </>
      )
    },
  },
]